var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"block-product"},[_c('figure',[_c('div',{staticClass:"imgwrap"},[_c('img',{attrs:{"src":_vm.getCategoryCoverImage,"alt":"cover"},on:{"error":function($event){return _vm.imageError($event)}}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }